exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".reset-form-wrapper {\n  width: 370px;\n  overflow: hidden; }\n  .reset-form-wrapper .reset-form-content {\n    display: flex;\n    width: 200%;\n    transition: all 1s ease; }\n  .reset-form-wrapper .button-wrapper {\n    margin-top: 20px; }\n  .reset-form-wrapper .confirmation-wrapper {\n    display: flex;\n    flex-direction: column;\n    justify-content: center; }\n    .reset-form-wrapper .confirmation-wrapper .link-wrapper {\n      margin-top: 39px; }\n  .reset-form-wrapper.confirmed .reset-form-content {\n    transform: translateX(-50%); }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/containers/ResetPassword/ResetPassword.scss
// module id = 1182
// module chunks = 0